<template>
  <section class="new_polish_sec">
    <div class="new_heading_image">
      <div class="new_polish_image">
        <div class="link_wrapper">
          <img
            v-lazy="shopifyData.polishImg.src"
            :src-placeholder="shopifyData.polishImg.placeholder"
            :alt="shopifyData.polishImg.alt || 'Polish Image'"
            loading="lazy"
            aria-hidden="true"
            aria-label="Polish Image"
            width=""
            height=""
            @click="showCard"
          />
          <div class="product_card_wrapper modify-slider">
            <swiper
              :class="{ active: isactive.includes(key) }"
              :modules="modules"
              :slides-per-view="'1'"
              :mousewheel="{ invert: false, releaseOnEdges: true }"
              :navigation="true"
            >
              <swiper-slide v-for="(product, index) in shopifyData.productData" :key="index">
                <productPopup :product-data="product" @close="toggle_selection_for(key)" />
              </swiper-slide>
            </swiper>
          </div>
        </div>
      </div>
      <div class="new_polish_text">
        <p class="new_polish_line">
          <span class="polish_heading" v-html="shopifyData.polishHeading" />
        </p>
        <span class="polish_brief" v-html="shopifyData.polishBrief" />
      </div>
    </div>
  </section>
</template>

<script>
// Producct Popup Component Import
import productPopup from '../product-popup.vue';
// Slider Import
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation, Autoplay, EffectFade } from 'swiper';
import 'swiper/css';
export default {
  components: {
    productPopup,
    Swiper,
    SwiperSlide,
  },

  props: {
    shopifyData: {
      type: Object,
      required: true,
    },
  },
  setup() {
    return {
      modules: [Navigation, Autoplay, EffectFade],
    };
  },
  data() {
    return {
      windowWidth: window.innerWidth,
      isactive: [],
    };
  },
  methods: {
    toggle_selection_for(key) {
      if (window.innerWidth <= 768) {
        if (this.isactive.includes(key)) {
          this.isactive = this.isactive.filter((item) => item !== key);
        } else {
          this.isactive.push(key);
        }
      }
    },
    showCard(e) {
      if (window.innerWidth <= 768) {
        e.target.nextElementSibling.classList.add('show');
      }
    },
  },
};
</script>

<style scoped>
.product_info_card {
  position: static;
  transform: unset;
}

.new_polish_sec {
  margin: 0 10%;
}

.new_polish_image {
  max-width: 746px;
  width: 100%;
}

.new_heading_image {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 30px;
}

.polish_heading {
  font-family: 'Big Caslon', sans-serif;
  line-height: 1;
  font-size: 48px;
}

.new_polish_line {
  /* line-height: 14px; */
  margin-bottom: 15px;
}

.polish_brief {
  font-family: 'adobe-caslon-pro', sans-serif;
  font-size: 14px;
  line-height: 18px;
}

/* @media only screen and (max-width: 1024px){
          .new_polish_line{
            line-height: 45px;
        }
    } */

@media only screen and (max-width: 767px) {
  .new_heading_image {
    flex-direction: column;
    gap: 0;
  }

  .new_polish_text {
    margin-top: 10%;
  }
}
</style>
